import { ContentContainer, Spinner } from '@ahc-digital/component-library';
import Script from 'next/script';
import { useState } from 'react';
import { sparkleUtils } from 'src/shared/sparkle-utils';
import { useSparkleApi } from 'src/shared/SparkleApi.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { E03EventConfirmationProps } from './E03EventConfirmation.types';

export const Default = (props: E03EventConfirmationProps): JSX.Element => {
  const [isError, setIsError] = useState(false);
  const sparkleApi = useSparkleApi();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const applyContent = async (confirmationId: string) => {
    const eventContentDiv = document.getElementById('event-content');
    if (!eventContentDiv) return;

    const { isSuccess, textContent: htmlContent } = await sparkleApi.fetchEventConfirmationContent(
      confirmationId
    );

    if (!isSuccess) {
      setIsError(true);
      return;
    }

    sparkleUtils.applyHtmlSnippet(htmlContent, eventContentDiv);
  };

  return (
    <>
      <Script
        src="https://code.jquery.com/jquery-3.7.1.min.js"
        integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo="
        crossOrigin="anonymous"
        onError={() => setIsError(true)}
        onReady={() => {
          const confirmationId = window.location.pathname.split('/').pop();
          if (confirmationId) {
            applyContent(confirmationId);
          }
        }}
      />
      <div
        id="event-content"
        className={translationClasses(props?.params)}
        data-component={marketingRenderingName}
      >
        {isError ? (
          <ContentContainer
            headline="Something went wrong"
            headlineTag="h3"
            spacing="40-24"
            supportCopy={
              <p>There was an error loading this event confirmation. Please try again later.</p>
            }
          />
        ) : (
          <ContentContainer spacing="40-24">
            <Spinner />
          </ContentContainer>
        )}
      </div>
    </>
  );
};
